export default __webpack_public_path__ + "static/pr2-b83482d902ee73a14ba6f6c6f6aec192.svg";